import React from 'react';
import { buttonClasses, Stack, styled } from '@mui/material';
import { Button } from 'components/Button/Button';
import { radius } from 'themes/radius';
import { DesktopAssessmentsPageNavigation } from './DesktopAssessmentsPageNavigation';
import { AssessmentsHeaderProps } from './types';
import { AuthSaveFlare } from './AutoSaveFlare';
import { AssessmentsPageInfo } from './AssessmentsPageInfo';
import { AssessmentsHeaderContainer } from './AssessmentsHeaderContainer';

const ButtonsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(1.5),
  marginLeft: 'auto',
}));

const SaveAndCloseButton = styled(Button)(({ theme }) => ({
  width: 160,
  borderRadius: radius.pill,
  [`&.${buttonClasses.disabled}`]: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    opacity: 0.5,
  },
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  width: 130,
  borderRadius: theme.spacing(4),
}));

export const AssessmentsDesktopHeader = ({
  currentPage,
  pages,
  onPageClick,
  onSaveAndClose,
  onSubmit,
  autoSaveStatus,
  isSaving = false,
  isSubmitting = false,
  hasAnsweredQuestion = false,
  isOnline = true,
}: AssessmentsHeaderProps) => {
  const saving = isSaving || isSubmitting;
  const actionsDisabled = saving || !hasAnsweredQuestion || !isOnline;

  return (
    <AssessmentsHeaderContainer>
      <AuthSaveFlare autoSaveStatus={autoSaveStatus} />
      <AssessmentsPageInfo currentPage={currentPage} totalPages={pages.length} />
      <DesktopAssessmentsPageNavigation
        currentPage={currentPage}
        pages={pages}
        onPageClick={onPageClick}
      />
      <ButtonsContainer>
        <SaveAndCloseButton
          id="assessment__desktop-header-save-and-close-button"
          variant="outlined"
          size="xlarge"
          onClick={onSaveAndClose}
          isLoading={isSaving}
          disabled={actionsDisabled}
          aria-label="Save and Close"
          circularProgressProps={{
            size: 24,
          }}
        >
          Save and Close
        </SaveAndCloseButton>
        <SubmitButton
          id="assessment__desktop-header-submit-button"
          variant="primary"
          size="xlarge"
          onClick={onSubmit}
          isLoading={isSubmitting}
          disabled={actionsDisabled}
          aria-label="Submit"
          circularProgressProps={{
            size: 24,
          }}
        >
          Submit
        </SubmitButton>
      </ButtonsContainer>
    </AssessmentsHeaderContainer>
  );
};
